$(document).ready(function () {
  window.AfterShipReview && window.AfterShipReview.init();

  jQuery('.slider-for').on('click',function(){
     jQuery('.image-wrap .product__photo-zoom').trigger('click');
  });
  if (window.location.href.indexOf("recover") !== -1) {
           jQuery('#RecoverPasswordForm').removeClass('hide');
           jQuery('#CustomerLoginForm').hide();
           jQuery('.login-page-title').html('Forgot Y<span class="custom-text">o</span>ur Password?');
          jQuery('.recover-text').show();
          jQuery('.recover-text').insertAfter('.login-page-title');
          // jQuery('.breadcrumbs__list li:nth-child(2) a').text('Forgot Your Password?');
              jQuery('.breadcrumbs__list').find('li').eq(1).text('Forgot Your Password?');
         
   }
  if ($('body').hasClass('template-customers-addresses')) {
    $('.account-icon-header').addClass('current-menu-item');
  }
  if ($('body').hasClass('template-customers-login')) {
    $('.account-icon-header').addClass('current-menu-item');
  }
   if ($('body').hasClass('template-customers-register')) {
    $('.account-icon-header').addClass('current-menu-item');
  }
  function initializeTabs() {
  jQuery('.tabs-contents .tab-content').hide();
  jQuery('.tabs-titles .tab-title').first().addClass('active');
  jQuery('.tabs-contents .tab-content').first().show();  
  jQuery('.tabs-contents .tab-content').first().addClass('active').show();
  jQuery('.tabs-contents .tab-content.active').show();   
  jQuery('.tabs-titles .tab-title').off('click').on('click', function() {
    var $this = jQuery(this);
    var isActive = $this.hasClass('active');

    jQuery('.tabs-titles .tab-title').removeClass('active');
    jQuery('.tabs-contents .tab-content').removeClass('active').hide();

    if (!isActive) {
      $this.addClass('active');
      var data_tab = $this.attr('data-tab');

      jQuery('.tabs-contents .tab-content').each(function() {
        if (jQuery(this).attr('id') === data_tab) {
          jQuery(this).addClass('active').show();
        }
      });
    }
  });
}
  
   setTimeout(function(){
     $('.image_grid_sec').append($('.product-tab-section'));
   },500);  
  setTimeout(function(){
      $('.grid--product-images--partial, .product-tab-section').wrapAll('<div class="product-tab-img-wrap"></div>');
   },300);
  setTimeout(function(){
     var tab_sec = jQuery('.product-tab-section').html();
     jQuery('<div class="shopify-section product-full-width product-tab-section mobile-tab-section">'+tab_sec+'</div>').insertBefore('.recommendation-section');
   // initializeTabs();
  },700)
  jQuery('.contact-link').on('click',function(){
    jQuery('.contact-popup').show();
    jQuery('html').addClass('open-popup');
    jQuery('html').addClass('no-scroll');
  });
  jQuery('.close-popup').on('click',function(){
     jQuery('.contact-popup').hide();
     jQuery('html').removeClass('open-popup');
     jQuery('html').removeClass('no-scroll');
  });
  //  setTimeout(function () {
  //     var urlParams = new URLSearchParams(window.location.search);
  //     var selectedVariantId = urlParams.get('variant');
  //    if (selectedVariantId) 
  //    {
  //       var selectedVariant = window.product.variants.find(v => v.id == selectedVariantId);
  //       if (selectedVariant && selectedVariant.featured_image) {
  //         var imageSrc = selectedVariant.featured_image.src.replace(/http(s)?:/, '');
  //           console.log(imageSrc);
  //         // Find the index of image in main slider
  //         var targetIndex = -1;
  //         $('.slider-for img').each(function(index){
  //           if ($(this).attr('src').includes(imageSrc)) {
  //             targetIndex = index;
  //           }
  //         });
      
  //         if (targetIndex >= 0) {
  //           $('.slider-for').slick('slickGoTo', targetIndex);
  //         }
  //         }
  //      }
  // }, 50);
 jQuery('.variant__button-label').on('click',function(){
   setTimeout(function () {
      var urlParams = new URLSearchParams(window.location.search);
      var selectedVariantId = urlParams.get('variant');
      var selectedVariant = window.product.variants.find(v => v.id == selectedVariantId);
      if (selectedVariant && selectedVariant.featured_image) {
        var imageSrc = selectedVariant.featured_image.src.replace(/http(s)?:/, '');
          console.log(imageSrc);
        // Find the index of image in main slider
        var targetIndex = -1;
        $('.slider-for img').each(function(index){
          if ($(this).attr('src').includes(imageSrc)) {
            targetIndex = index;
          }
        });
    
        if (targetIndex >= 0) {
          $('.slider-for').slick('slickGoTo', targetIndex);
        }
      }
  }, 50);
  
}); 
  
   if ($('#RecoverPasswordForm').is(':visible')) {
      jQuery('.login-page-title').html('Forgot Y<span class="custom-text">o</span>ur Password?');
      jQuery('.recover-text').show();
      jQuery('.recover-text').insertAfter('.login-page-title');
      // jQuery('.breadcrumbs__list li:nth-child(2) a').text('Forgot Your Password?');
          jQuery('.breadcrumbs__list').find('li').eq(1).text('Forgot Your Password?');
    }
$(document).on('click', '.quick-view-btn', function () {
  const handle = $(this).data('handle');

  fetch(`/products/${handle}?view=quick-view`)
    .then(res => res.text())
    .then(html => {
      $('#quick-view-modal .quick-view-content').html(html);
      $('#quick-view-modal').fadeIn();

      // Init Slick Sliders
     if ($.fn.slick) {
          $('.quick-view-slider-for').not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.quick-view-slider-nav'
          });
        
          $('.quick-view-slider-nav').not('.slick-initialized').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.quick-view-slider-for',
            vertical: true,
            verticalSwiping: true,
            focusOnSelect: true
          });
        } else {
          console.warn('Slick Slider is not loaded.');
        }

    });
});

// Close popup
$(document).on('click', '.close-quick-view', function () {
  $('#quick-view-modal').fadeOut();
});
  jQuery('.AddressPhone').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
  });
  jQuery('#ContactFormPhone').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
  });   
  jQuery('#ContactFormPhone-contact-details').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
  });
   jQuery('#AddressPhoneNew').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
  });
  jQuery('.template-collection .collapsible-trigger-btn').trigger('click');
   jQuery('.popup-contact-btn').on('click',function(e){
      jQuery('.note--success').hide();
      jQuery('.error-msg').remove();
      jQuery('#ContactFormName').removeClass('error');
      jQuery('#ContactFormLastName').removeClass('error');
      jQuery('#ContactFormPhone').removeClass('error');
      jQuery('#ContactFormEmail').removeClass('error');
      jQuery('#ContactFormMessage').removeClass('error');
      
          var Name = jQuery("#ContactFormFirstName").val();
          var LName = jQuery("#ContactFormLastName").val();
          var phone = jQuery("#ContactFormPhone").val();
          var email = jQuery("#ContactFormEmail").val();
          var message = jQuery("#ContactFormMessage").val(); 
             // var response = grecaptcha.getResponse();
             //    if (response.length === 0) {
             //      e.preventDefault(); // stop form from submitting
             //      jQuery('.g-recaptcha').append('<span class="error-msg">Please complete the CAPTCHA.</span>');
             //    }
              if(!phone) {
                   e.preventDefault();
                    jQuery('#ContactFormPhone').addClass('error');
                    jQuery('<span class="error-msg">Please enter phone number</span>').insertAfter('#ContactFormPhone');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormPhone').removeClass('error');
                }
              if(!LName) {
                   e.preventDefault();
                    jQuery('#ContactFormLastName').addClass('error');
                    jQuery('<span class="error-msg">Please enter last name</span>').insertAfter('#ContactFormLastName');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormLastName').removeClass('error');
                }
              if(!message) {
                   e.preventDefault();
                    jQuery('#ContactFormMessage').addClass('error');
                    jQuery('<span class="error-msg">Please enter message</span>').insertAfter('#ContactFormMessage');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormMessage').removeClass('error');
                }
               if(!Name) {
                   e.preventDefault();
                    jQuery('#ContactFormFirstName').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('#ContactFormFirstName');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormFirstName').removeClass('error');
                }
                 if(!email)
             	 {
                   jQuery('#ContactFormEmail').addClass('error');
                   jQuery('<span class="error-msg">Please enter email address</span>').insertAfter('#ContactFormEmail');
             	 }
             	 else
                {
                  //console.log("denmjb");
                  if( !validateEmail(email))
                   { 

                    jQuery('#ContactFormEmail').addClass('error');
                    emailError = 1;
                    jQuery('<span class="error-msg">Please enter a valid email address</span>').insertAfter('#ContactFormEmail');

                   }
                else {
                   
                    jQuery('#ContactFormEmail').removeClass('error');
                     }
              }
  });
  jQuery('.product-contact-btn').on('click',function(e){
      jQuery('.note--success').hide();
      jQuery('.error-msg').remove();
      jQuery('#ContactFormName-contact').removeClass('error');
      jQuery('#ContactFormEmail-contact').removeClass('error');
      jQuery('#ContactFormMessage-contact').removeClass('error');
          var Name = jQuery("#ContactFormName-contact").val();
          var email = jQuery("#ContactFormEmail-contact").val();
          var message = jQuery("#ContactFormMessage-contact").val(); 
              if(!message) {
                   e.preventDefault();
                    jQuery('#ContactFormMessage-contact').addClass('error');
                    jQuery('<span class="error-msg">Please enter message</span>').insertAfter('#ContactFormMessage-contact');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormMessage-contact').removeClass('error');
                }
               if(!Name) {
                   e.preventDefault();
                    jQuery('#ContactFormName-contact').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('#ContactFormName-contact');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormName-contact').removeClass('error');
                }
                 if(!email)
             	 {
                    e.preventDefault();
                   jQuery('#ContactFormEmail-contact').addClass('error');
                   jQuery('<span class="error-msg">Please enter email address</span>').insertAfter('#ContactFormEmail-contact');
             	 }
             	 else
                {
                  //console.log("denmjb");
                  if( !validateEmail(email))
                   { 
                      e.preventDefault();
                    jQuery('#ContactFormEmail-contact').addClass('error');
                    emailError = 1;
                    jQuery('<span class="error-msg">Please enter a valid email address</span>').insertAfter('#ContactFormEmail-contact');

                   }
                else {
                   
                    jQuery('#ContactFormEmail-contact').removeClass('error');
                     }
              }
  });
   $(".collection-list-section .section-header__title").each(function () {
        var text = $(this).text();
        if (text.length >= 3) {
            var modifiedText = text.substring(0, 2) + "<span class='custom-text'>" + text.charAt(2) + "</span>" + text.substring(3);
            $(this).html(modifiedText);
        }
    
  });
   // $('.rte--collection-desc .enlarge-text p').first().hide();
  var $desc = $('.rte--collection-desc .enlarge-text').first();
  if ($desc.length && typeof $desc.html() === 'string') {
 
    var fullHtml = $desc.html().trim(); // Get the full HTML content

// Create a temporary div to extract text content
var tempDiv = $('<div>').html(fullHtml);
var fullText = tempDiv.text().trim();
var words = fullText.split(/\s+/);

if (words.length > 50) {
  var shortText = words.slice(0, 50).join(' ') + '...';

  // Store full HTML as data attribute
  $desc.data('full-html', fullHtml);
  $desc.data('short-text', shortText);
  $desc.html(shortText);

  $('.view_more_btn').show();

  $('.view_more_btn').click(function () {
    var isExpanded = $(this).text() === 'View Less';
    $desc.html(isExpanded ? $desc.data('short-text') : $desc.data('full-html'));
    $(this).text(isExpanded ? 'View More' : 'View Less');
  });
  }
  }
    if (window.location.href.includes('contact_posted=true')) {
      var newsletterPopup = document.getElementById('shopify-section-newsletter-popup');
      if (newsletterPopup) {
        newsletterPopup.style.display = 'none';
        jQuery('html').removeClass('modal-open');
      }
    } 
   jQuery('#update-cart').on('click', function() {
       jQuery('#CartPageForm').submit();
   });
   jQuery('.js-qty__wrapper').each(function() {
      var $wrapper = jQuery(this);
      var $input = $wrapper.find('.js-qty__num');
       
      // Actual PLUS logic (button with .minus class due to icon mislabel)
      $wrapper.find('.minus').on('click', function() {
        var currentVal = parseInt($input.val()) || 0;
        $input.val(currentVal + 1).change();
      });
  
      // Actual MINUS logic (button with .plus class due to icon mislabel)
      $wrapper.find('.plus').on('click', function() {
        var currentVal = parseInt($input.val()) || 0;
        if (currentVal > 1) {
          $input.val(currentVal - 1).change();
        }
      });
  });
 //====================  product page tab js ======================= 
 
  if (window.location.href.includes('contact_posted=true')) {
  setTimeout(function(){
     jQuery('.template-product .tabs-contents .tab-content').hide();
     jQuery('.template-product .tabs-titles .tab-title').eq(2).addClass('active');
     jQuery('.template-product .tabs-contents .tab-content').eq(2).addClass('active').show();
    },500);
  } else {
    jQuery('.tabs-contents .tab-content').hide();
    jQuery('.tabs-titles .tab-title').first().addClass('active');
    jQuery('.tabs-contents .tab-content').first().addClass('active');
    jQuery('.tabs-contents .tab-content').first().show();
  }
  jQuery('.tabs-titles .tab-title').on('click', function() {
  var $this = jQuery(this);
  var isActive = $this.hasClass('active'); // check before removing

  jQuery('.tabs-titles .tab-title').removeClass('active');
  jQuery('.tabs-contents .tab-content').removeClass('active').hide();

  if (!isActive) {
    $this.addClass('active');

    var data_tab = $this.attr('data-tab');
    jQuery('.tabs-contents .tab-content').each(function() {
      var con_data_tab = jQuery(this).attr('id');
      if (data_tab === con_data_tab) {
        jQuery(this).addClass('active').show();
      }
    });
  }
});
setTimeout(function(){
jQuery('.mobile-tab-section .tabs-titles .tab-title').on('click', function() {
  var $this = jQuery(this);
  var isActive = $this.hasClass('active'); // check before removing

  jQuery('.mobile-tab-section .tabs-titles .tab-title').removeClass('active');
  jQuery('.mobile-tab-section .tabs-contents .tab-content').removeClass('active').hide();

  if (!isActive) {
    $this.addClass('active');

    var data_tab = $this.attr('data-tab');
    jQuery('.mobile-tab-section .tabs-contents .tab-content').each(function() {
      var con_data_tab = jQuery(this).attr('id');
      if (data_tab === con_data_tab) {
        jQuery(this).addClass('active').show();
      }
    });
  }
  });
},1000);  
  jQuery('.update-address').on('click',function(e){
      var Name = jQuery('.AddressFirstName').val();
      var lname = jQuery('.AddressLastName').val();
      var address1 = jQuery('.AddressAddress1').val();
      var city = jQuery('.AddressCity').val();
      var zipcode = jQuery('.AddressZip').val();
      var phone = jQuery('.AddressPhone').val();
      var country = jQuery('.AddressCountry').val();     
             if(country == '---') {
              e.preventDefault();
                    jQuery('.AddressCountry').addClass('error');
                    jQuery('<span class="error-msg">Please select country</span>').insertAfter('.AddressCountry');
                    NameError = 1;
                } else {
                    jQuery('.AddressCountry').removeClass('error');
                }
            if(!phone) {
              e.preventDefault();
                    jQuery('.AddressPhone').addClass('error');
                    jQuery('<span class="error-msg">Please enter phone number</span>').insertAfter('.AddressPhone');
                    NameError = 1;
                } else {
                    jQuery('.AddressPhone').removeClass('error');
                }
            if(!zipcode) {
              e.preventDefault();
                    jQuery('.AddressZip').addClass('error');
                    jQuery('<span class="error-msg">Please enter zipcode</span>').insertAfter('.AddressZip');
                    NameError = 1;
                } else {
                    jQuery('.AddressZip').removeClass('error');
                }
            if(!city) {
              e.preventDefault();
                    jQuery('.AddressCity').addClass('error');
                    jQuery('<span class="error-msg">Please enter city</span>').insertAfter('.AddressCity');
                    NameError = 1;
                } else {
                    jQuery('.AddressCity').removeClass('error');
                }
            if(!Name) {
              e.preventDefault();
                    jQuery('.AddressFirstName').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('.AddressFirstName');
                    NameError = 1;
                } else {
                    jQuery('.AddressFirstName').removeClass('error');
                }
            if(!lname) {
              e.preventDefault();
                    jQuery('.AddressLastName').addClass('error');
                    jQuery('<span class="error-msg">Please enter last name</span>').insertAfter('.AddressLastName');
                    NameError = 1;
                } else {
                    jQuery('.AddressLastName').removeClass('error');
                }
            if(!address1) {
              e.preventDefault();
                    jQuery('.AddressAddress1').addClass('error');
                    jQuery('<span class="error-msg">Please enter address</span>').insertAfter('.AddressAddress1');
                    NameError = 1;
                } else {
                    jQuery('.AddressAddress1').removeClass('error');
                }

    
  });
  jQuery('.AddressProvince').parent().parent().addClass('has-focus');
  jQuery('.AddressCountry').parent().parent().addClass('has-focus');
 jQuery('.new-address').on('click',function(e){
    var Name = jQuery('#AddressFirstNameNew').val();
    var lname = jQuery('#AddressLastNameNew').val();
    var address1 = jQuery('#AddressAddress1New').val();
    var city = jQuery('#AddressCityNew').val();
    var zipcode = jQuery('#AddressZipNew').val();
    var phone = jQuery('#AddressPhoneNew').val();
    var country = jQuery('#AddressCountryNew').val();     
             if(country == '---') {
              e.preventDefault();
                    jQuery('#AddressCountryNew').addClass('error');
                    jQuery('<span class="error-msg">Please select country</span>').insertAfter('#AddressCountryNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressCountryNew').removeClass('error');
                }
            if(!phone) {
              e.preventDefault();
                    jQuery('#AddressPhoneNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter phone number</span>').insertAfter('#AddressPhoneNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressPhoneNew').removeClass('error');
                }
            if(!zipcode) {
              e.preventDefault();
                    jQuery('#AddressZipNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter zipcode</span>').insertAfter('#AddressZipNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressZipNew').removeClass('error');
                }
            if(!city) {
              e.preventDefault();
                    jQuery('#AddressCityNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter city</span>').insertAfter('#AddressCityNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressCityNew').removeClass('error');
                }
            if(!Name) {
              e.preventDefault();
                    jQuery('#AddressFirstNameNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('#AddressFirstNameNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressFirstNameNew').removeClass('error');
                }
            if(!lname) {
              e.preventDefault();
                    jQuery('#AddressLastNameNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter last name</span>').insertAfter('#AddressLastNameNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressLastNameNew').removeClass('error');
                }
            if(!address1) {
              e.preventDefault();
                    jQuery('#AddressAddress1New').addClass('error');
                    jQuery('<span class="error-msg">Please enter address</span>').insertAfter('#AddressAddress1New');
                    NameError = 1;
                } else {
                    jQuery('#AddressAddress1New').removeClass('error');
                }

 });

  
  jQuery('.cerave-collection-text').insertAfter('.collection-grid__wrapper');
  jQuery('.description-tab').trigger('click');
  jQuery('.product-block--tab').on('click',function(){
    jQuery('.product-block--tab button').removeClass('is-open');
    jQuery('.product-block--tab .collapsible-content').removeClass('is-open');
    jQuery(this).find('button').addClass('is-open');
     jQuery(this).find('.collapsible-content').addClass('is-open');
});
 jQuery('#RecoverPassword').on('click',function(){
    if ($('#RecoverPasswordForm').is(':visible')) {
      jQuery('.login-page-title').html('Forgot Y<span class="custom-text">o</span>ur Password?');
      jQuery('.recover-text').show();
      jQuery('.recover-text').insertAfter('.login-page-title');
      // jQuery('.breadcrumbs__list li:nth-child(2) a').text('Forgot Your Password?');
          jQuery('.breadcrumbs__list').find('li').eq(1).text('Forgot Your Password?');
    } 
  });
  jQuery('#HideRecoverPasswordLink').on('click',function(){
     if ($('#CustomerLoginForm').is(':visible')) {
      jQuery('.login-page-title').html('L<span class="custom-text">o</span>gin');
      jQuery('.recover-text').hide();
      //jQuery('.recover-text').insertAfter('.login-page-title');
      // jQuery('.breadcrumbs__list li:nth-child(2) a').text('Login');
    } 
    
  });
// Function to check if an element is in the viewport
 $(document).ready(function () {
    const $sticky = $('.product-single__sticky'); // element to make sticky
    const $stopTrigger = $('.recommendation-section'); // section that disables stickiness
    const stickyOffset = 100; // when to start being sticky

    function handleSticky() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      const stopTop = $stopTrigger.offset().top;
      const stopHeight = $stopTrigger.outerHeight();
      const stopBottom = stopTop + stopHeight;

      const stickyStart = scrollTop > stickyOffset;
      const stopInView = scrollTop + windowHeight > stopTop + 270;

      if (stickyStart && !stopInView) {
        $sticky.addClass('sticky_product_detail');
      } else {
        $sticky.removeClass('sticky_product_detail');
      }
    }

    // Run on scroll and resize
    $(window).on('scroll resize', handleSticky);

    // Run once on page load
    handleSticky();
  });



   jQuery(window).scroll(function() {
        var sticky = jQuery('body');
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) sticky.addClass('sticky_header');
        else sticky.removeClass('sticky_header');
    });
   jQuery('.site-header__search-btn').on('click',function(e){
     jQuery('.error-msg').remove();
     var key_word = jQuery('.site-header__search-input').val();
      if(key_word == '')
       {
           e.preventDefault();
           jQuery('.site-header__search-input').addClass('error');
           jQuery('<span class="error-msg">Please enter keyword</span>').insertAfter('.site-header__search-input');
       }  
   });
   jQuery('.search-btn').on('click',function(e){
     jQuery('.error-msg').remove();
     var key_word = jQuery('.search-input').val();
      if(key_word == '')
       {
           e.preventDefault();
           jQuery('.search-input').addClass('error');
           jQuery('<span class="error-msg">Please enter keyword</span>').insertAfter('.search-form');
       }  
   });
   jQuery(".site-nav__compress-menu").click(function() {
    jQuery("html").toggleClass("no-scroll");
  });
    if (window.innerWidth < 768) {
    jQuery(window).scroll(function () {
      var sticky = jQuery("body"),
        scroll = jQuery(window).scrollTop();
  
      if (scroll >= 100) sticky.addClass("sticky_header");
      else sticky.removeClass("sticky_header");
    });
  }

  // jQuery('.newsletter__input-group .btn').on('click',function(e){
  //   jQuery('.error-msg').remove();
  // var email = jQuery('#Email-footer').val();
  //   if(email == '')
  //    {
  //        e.preventDefault();
  //         jQuery('#Email-footer').addClass('error');
  //        jQuery('<span class="error-msg">Please Enter Keyword</span>').insertAfter('.newsletter__input-group');
  //    } 
   jQuery('#sign-up-newsletter').on('click', function(e) {
        jQuery('.error_msg').remove();
        var email = jQuery('#Email-footer').val();
        if (email === '') {
            e.preventDefault();  // Prevent form submission
            jQuery('#Email-footer').addClass('error');  // Add error class to input field
            jQuery('<span class="error_msg">This field is required</span>').insertAfter('#Email-footer');  // Display error message
        } else {
            if (validateEmail(email)) {
               jQuery('#Email-footer').removeClass('error');  // Remove error class if email is valid
            } else {
                e.preventDefault();  // Prevent form submission
               jQuery('#Email-footer').addClass('error');  // Add error class to input field
                jQuery('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('#Email-footer');  // Display error message
            }
        }
    });
    // Email validation function
    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
 
    //$( ".tab-product-wrap .tab-content" ).hide();  
    $('.product-tab li').click(function(){
      $('.product-tab li').removeClass('active');
      $(this).addClass('active'); 
       var activeTab = $(this).attr('id');
       $( ".tab-product-wrap .tab-content" ).each(function( index ) {
               var content_id = $( this ).attr('id');
           //  $( ".tab-product-wrap .tab-content" ).hide();
               if(activeTab == content_id)
               {
                 $( ".tab-product-wrap .tab-content" ).hide();
                 console.log(activeTab);
                 console.log(content_id);
                   $( this ).show();
               }
          });
      });
//================ focus js ==============
   jQuery('input,textarea').on('focus', function() {
    jQuery(this).parent().addClass('has-focus');
  });

  jQuery('input,textarea').on('focusout', function() {
    if(jQuery(this).val() == '') {
      jQuery(this).parent().removeClass('has-focus');
    }
  }); 

   $('input, textarea').each(function() {
    if ($(this).val().trim() !== '') {
      $(this).parent().addClass('has-focus');
    }
  });
  //============active header menu ============
     // Get the current URL path
    var currentPath = window.location.pathname;

    // Loop through each nav link and compare the href with the current path
    jQuery('.site-nav__link').each(function() {
      if (jQuery(this).attr('href') === currentPath) {
        // Add the 'active' class if the href matches the current path
       jQuery(this).addClass('current-menu-item');
      }
    });
  // Get the current URL path
    var currentPath = window.location.pathname;

    // Function to add 'active' class to matching links in navigation and footer menus
    jQuery('a').each(function() {
      if (jQuery(this).attr('href') === currentPath) {
        jQuery(this).addClass('current-menu-item');
      }
    });
//================= Register page js ==================
  function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( $email );
  }
  function validatePassword(password) {
    // Password must contain at least one letter, one digit, and one special character
    var re = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~])[A-Za-z\d!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~]{6,}$/;
    return re.test(password);
}
 jQuery('.register-btn').click(function()
     {
     //e.preventDefault();
    var reg_flg,reg_pwd  = 0,reg_frstname = 0,reg_lastname =0;
    var fname = jQuery('#FirstName').val();
    var lname = jQuery("#LastName").val(); 
    var email = jQuery("#Email").val();
     jQuery('.error-msg').remove();
    var password = jQuery("#CreatePassword").val();
  
              if(fname == '')
              {

                  jQuery('#FirstName').addClass('error');
                  reg_frstname =1;
                  jQuery( "<p class='error-msg'>Please enter a first name</p>" ).insertAfter( ".firstname-wrap" );

              }
              else
              {
                jQuery('#FirstName').removeClass('error');
                reg_frstname =0;
              }		
              if(lname == "")
              {
                jQuery('#LastName').addClass('error');
                jQuery( "<p class='error-msg'>Please enter a last name</p>" ).insertAfter( ".lastname-wrap" );

                 reg_lastname=1;
              }
              else
              {
                jQuery('#LastName').removeClass('error');
                reg_lastname =0;
              }
  			if(email == "")
              {
                jQuery('#Email').addClass('error');
                jQuery( "<p class='error-msg'>Please enter a email address</p>" ).insertAfter( ".email-wrap" );

                reg_flg =1;
              }
              else if( !validateEmail(email))
              {
                  console.log("401");
                  jQuery('#Email').addClass('error');
                 jQuery( "<p class='error-msg'>Please enter a valid email address</p>" ).insertAfter( ".email-wrap" );

              		reg_flg =2;
                }
                else
                {
                  reg_flg = 0;
                   jQuery('#Email').removeClass('error');
                   
                }
            
              // if(password == "")
              // {
              //   jQuery('#CreatePassword').addClass('error');
              //   jQuery( "<p class='error-msg'>Please enter a password</p>" ).insertAfter( ".password-wrap" );
              //   reg_pwd =1;
              // }
              // else
              // {
              //   jQuery('#CreatePassword').removeClass('error');
              //   reg_pwd = 0;
              // }
           // Password Validation
                if (password == "") {
                    jQuery('#CreatePassword').addClass('error');
                    jQuery("<p class='error-msg'>Please enter a password</p>").insertAfter(".password-wrap");
                    reg_pwd = 1;
                } else if (password.length < 6) {
                    jQuery('#CreatePassword').addClass('error');
                    jQuery("<p class='error-msg'>Password must be at least 6 characters long</p>").insertAfter(".password-wrap");
                    reg_pwd = 1;
                } else if (!validatePassword(password)) {
                    jQuery('#CreatePassword').addClass('error');
                    jQuery("<p class='error-msg'>Password must contain at least one digit and one special character</p>").insertAfter(".password-wrap");
                    reg_pwd = 1;
                } else {
                    jQuery('#CreatePassword').removeClass('error');
                    reg_pwd = 0;
                }

    
    if(reg_flg == 1 || reg_pwd == 1 ||  reg_frstname == 1 ||  reg_lastname == 1 )
    {
          
          jQuery( "<p class='error-msg all-field-err'>One or more fields have an error. Please check and try again.</p>" ).insertAfter( ".register-btn" );
            return false;
    }
    else if(reg_flg == 2)
    {
			
                   jQuery( "<p class='error-msg'>Please enter a valid email address</p>" ).insertAfter( ".email-wrap" );
                   return false;
    }
      else
              {
                jQuery( "<p></p>" ).insertAfter( ".register-btn" );
                return true;
              }

 
          });   
//==================== login page js ========================
  jQuery('#login-btn').click(function(e)
     {
      var login_flg,login_pwd  = 0;
      var email = jQuery("#CustomerEmail").val();
      var password = jQuery("#CustomerPassword").val(); 
      jQuery('.error-msg').remove(); 
  			if(email == "")
              {
                e.preventDefault();
                jQuery('#CustomerEmail').addClass('error');
                jQuery( "<p class='error-msg'>Please enter a email address</p>" ).insertAfter( "#CustomerEmail" );

                login_flg =1;
              }
              else if( !validateEmail(email))
              {
                  e.preventDefault();
                  jQuery('#CustomerEmail').addClass('error');
                  jQuery( "<p class='error-msg'>Please enter a valid email address</p>" ).insertAfter( "#CustomerEmail" );
              		login_flg =2;
                }
                else
                {
                  login_flg = 0;
                   jQuery('#CustomerEmail').removeClass('error');
                   
                }
            
              if(password == "")
              {
                e.preventDefault();
                jQuery('#CustomerPassword').addClass('error');
                jQuery( "<p class='error-msg'>Please enter a password</p>" ).insertAfter( "#CustomerPassword" );
                login_pwd =1;
              }
              else
              {
                jQuery('#CustomerPassword').removeClass('error');
                login_pwd = 0;
              }
    
    if(login_flg == 1 || login_pwd == 1)
    {
        jQuery( "<p class='error-msg all-field-err'>One or more fields have an error. Please check and try again.</p>" ).insertAfter( "#login-btn" );
        return false;
    }
   
          });   
//================== forgot password js =================
jQuery('.forgot-btn').click(function()
  {  
    var flag = 0;
    var email = jQuery("#RecoverEmail").val();  
   if(email == "")
              {
                jQuery('#RecoverEmail').addClass('error');
                
              }
              else
              {
                if( !validateEmail(email))
                 { 
                  jQuery('#RecoverEmail').addClass('error');
                  
                 }
                else
                {
                   jQuery('#RecoverEmail').removeClass('error');
                   
                }
              } 
  
  if(jQuery('#RecoverEmail').hasClass('error'))
              {     
                if(email!="")  
                {
                  jQuery('.error-msg').remove();
                   jQuery( "<p class='error-msg'>Please enter a valid email address</p>" ).insertAfter( "#RecoverEmail" );
                   return false;	
                }
                else{
                  
                  jQuery('.error-msg').remove();
                   jQuery( "<p class='error-msg'>Please enter an email address.</p>" ).insertAfter( "#RecoverEmail" );   
                   return false;
                }
                
         }
          }); 
  //=====================  brand logo js ==================
  jQuery('.logo-brand').owlCarousel({
          loop:true,
          margin:10,
          nav:true,
          responsive:{
              0:{
                  items:2
              },
              600:{
                  items:2
              },
              1000:{
                  items:6
              }
          }
      }); 
    jQuery('.our-products-slider').owlCarousel({
          loop:true,
          margin:28,
          nav:true,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:2
              },
              1024: {  // iPad Landscape (Width: 1024px)
                  items: 3
              },
              1200:{
                  items:4
              }
          }
      }); 
 setTimeout(function(){
  jQuery('.modal--quick-shop').remove(); 
  jQuery('.RecentlyViewed .product-grid').addClass('owl-carousel');
   jQuery('.RecentlyViewed .product-grid').owlCarousel({
          stagePadding: 30,
          loop:true,
          margin:10,
          nav:true,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:3
              },
              1024: {  // iPad Landscape (Width: 1024px)
                  items: 3
              },
              1200:{
                  items:4
              }
          }
      }); 
    jQuery('.product-recommendations .product-grid').owlCarousel({
          stagePadding: 30,
          loop:true,
          margin:10,
          nav:true,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:3
              },
              1024: {  // iPad Landscape (Width: 1024px)
                  items:3
              },
              1200:{
                  items:4
              }
          }
      }); 
   },5000);

    $(".collection-title").each(function () {
        var text = $(this).text();
        if (text.length >= 3) {
            var modifiedText = text.substring(0, 2) + "<span class='custom-text'>" + text.charAt(2) + "</span>" + text.substring(3);
            $(this).html(modifiedText);
        }
    
  });
 jQuery('.reset-all').on('click', function () {
     jQuery('.tag-list .tag--active').each(function () {
            jQuery(this).find('.tag__input').trigger('click');
        });
   
  });
//============================= contact form js ==========================
 jQuery('.contact-btn').click(function(e)
          {
               jQuery('.note--success').hide();
               jQuery('#not-valid-ins').hide();
               jQuery('#form-comment-after').hide();
               jQuery('.error-msg').hide();
               var NameError = 0;
               var LName = 0;
               var emailError = 0;
               var messageErrors = 0;
               var phoneErrors = 0;

             var Name = jQuery("#ContactFormName-contact-details").val();
             var LName = jQuery("#ContactFormLastName").val();
             var email = jQuery("#ContactFormEmail-contact-details").val();
             var phone = jQuery("#ContactFormPhone-contact-details").val();
             var message = jQuery("#ContactFormMessage-contact-details").val();
                
           
               if(!Name) {
                    jQuery('#ContactFormName-contact-details').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('#ContactFormName-contact-details');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormName-contact-details').removeClass('error');
                }

                if(!LName) {
                    jQuery('#ContactFormLastName').addClass('error');
                    jQuery('<span class="error-msg">Please enter last name</span>').insertAfter('#ContactFormLastName');
                    NameError = 1;
                } else {
                    jQuery('#ContactFormLastName').removeClass('error');
                }

                // if(!phone) {
                //     jQuery('#ContactFormPhone-contact-details').addClass('error');
                //     jQuery('<span class="error-msg">Please Enter Phone Number</span>').insertAfter('#ContactFormPhone-contact-details');
                //     NameError = 1;
                // } else {
                //     jQuery('#ContactFormPhone-contact-details').removeClass('error');
                // }
                if(!phone) {
                    jQuery('#ContactFormPhone-contact-details').addClass('error');
                    jQuery('<span class="error-msg">Please enter phone number</span>').insertAfter('#ContactFormPhone-contact-details');
                    phoneErrors = 1;
                } else if (!/^\+?[0-9\s\-]{7,15}$/.test(phone)) {
                    jQuery('#ContactFormPhone-contact-details').addClass('error');
                    jQuery('<span class="error-msg">Please enter a valid phone number</span>').insertAfter('#ContactFormPhone-contact-details');
                    phoneErrors = 1;
                } else {
                    jQuery('#ContactFormPhone-contact-details').removeClass('error');
                }
            
                 if(!email)
             	 {
                   jQuery('#ContactFormEmail-contact-details').addClass('error');
                   jQuery('<span class="error-msg">Please enter email address</span>').insertAfter('#ContactFormEmail-contact-details');
             	 }
             	 else
                {
                  //console.log("denmjb");
                  if( !validateEmail(email))
                   { 

                    jQuery('#ContactFormEmail-contact-details').addClass('error');
                    emailError = 1;
                    jQuery('<span class="error-msg">Please enter a valid email address</span>').insertAfter('#ContactFormEmail-contact-details');

                   }
                else {
                   
                    jQuery('#ContactFormEmail-contact-details').removeClass('error');
                     }
              }
              if(!message)
              {
                jQuery('#ContactFormMessage-contact-details').addClass('error');
                jQuery('<span class="error-msg">Please enter a message</span>').insertAfter('#ContactFormMessage-contact-details');
                messageErrors=1;
              }
              else
              {
                jQuery('#ContactFormMessage-contact-details').removeClass('error');
                
              }
            
          if( NameError || emailError || messageErrors  || phoneErrors) {
				e.preventDefault();
				var errorHTML = '<span id ="form-comment-after">One or more fields have an error. Please check and try again</span>';
				jQuery(errorHTML).insertAfter('#contact-form');
                   jQuery('#form-comment-after').hide();       
                   return false;
          
			}
     else
     {
       return true;
     }
		});

  //=============================
  jQuery('.reset-pass').on('click', function(e){
    var password = jQuery('#ResetPassword').val();
    var Confirmation = jQuery('#PasswordConfirmation').val();
    var reg_pwd = 0;

    // Remove any previous errors
    jQuery('#ResetPassword').removeClass('error');
    jQuery('#PasswordConfirmation').removeClass('error');
    jQuery('.error-msg').remove();

    if (password === "") {
        e.preventDefault();
        jQuery('#ResetPassword').addClass('error');
        jQuery("<p class='error-msg'>Please enter a password</p>").insertAfter("#ResetPassword");
        reg_pwd = 1;
    } else if (password.length < 6) {
        e.preventDefault();
        jQuery('#ResetPassword').addClass('error');
        jQuery("<p class='error-msg'>Password must be at least 6 characters long</p>").insertAfter("#ResetPassword");
        reg_pwd = 1;
    } else if (!validatePassword(password)) {
        e.preventDefault();
        jQuery('#ResetPassword').addClass('error');
        jQuery("<p class='error-msg'>Password must contain at least one digit and one special character</p>").insertAfter("#ResetPassword");
        reg_pwd = 1;
    }

    if (Confirmation === "") {
        e.preventDefault();
        jQuery('#PasswordConfirmation').addClass('error');
        jQuery("<p class='error-msg'>Please enter a confirmation password</p>").insertAfter("#PasswordConfirmation");
        reg_pwd = 1;
    } else if (Confirmation.length < 6) {
        e.preventDefault();
        jQuery('#PasswordConfirmation').addClass('error');
        jQuery("<p class='error-msg'>Confirmation password must be at least 6 characters long</p>").insertAfter("#PasswordConfirmation");
        reg_pwd = 1;
    } else if (!validatePassword(Confirmation)) {
        e.preventDefault();
        jQuery('#PasswordConfirmation').addClass('error');
        jQuery("<p class='error-msg'>Confirmation password must contain at least one digit and one special character</p>").insertAfter("#PasswordConfirmation");
        reg_pwd = 1;
    } else if (password !== Confirmation) {
      e.preventDefault();
        jQuery('#PasswordConfirmation').addClass('error');
        jQuery("<p class='error-msg'>Passwords do not match</p>").insertAfter("#PasswordConfirmation");
        isValid = false;
    }

  });
 jQuery('.toggle-password').on('click', function(){
    var input = jQuery(jQuery(this).attr('toggle'));
    var type = input.attr('type') === 'password' ? 'text' : 'password';
    input.attr('type', type);
     jQuery('.toggle-password').toggleClass('dashicons-visibility')
    // Optional: Change icon when toggling
  });
   jQuery('.conf-toggle-password').on('click', function(){
    var input = jQuery(jQuery(this).attr('toggle'));
    var type = input.attr('type') === 'password' ? 'text' : 'password';
    input.attr('type', type);
     jQuery('.conf-toggle-password').toggleClass('dashicons-visibility')
    // Optional: Change icon when toggling
  });

// $('.slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   asNavFor: '.slider-nav'
// });

// $('.slider-nav').slick({
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   asNavFor: '.slider-for',
//   dots: false,
//   vertical: true,
//   verticalSwiping: true,
//   focusOnSelect: true
// });
$(document).ready(function() {
  // Initialize Slick
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true
  });

  // // Build PhotoSwipe items only from non-cloned slides
  // var items = [];
  // $('.slider-for .slick-slide:not(.slick-cloned) a').each(function() {
  //   var $link = $(this);
  //   items.push({
  //     src: $link.attr('href'),
  //     w: parseInt($link.data('pswp-width'), 10),
  //     h: parseInt($link.data('pswp-height'), 10),
  //     title: $link.find('img').attr('alt')
  //   });
  // });

  // var pswpElement = document.querySelectorAll('.pswp')[0];

  // // Trigger PhotoSwipe on clicking real slides only
  // $('.slider-for').on('click', '.slick-slide:not(.slick-cloned) a', function(e) {
  //   e.preventDefault();
  //   var index = $('.slider-for .slick-slide:not(.slick-cloned) a').index(this);
  //   var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
  //     index: index,
  //     bgOpacity: 0.8,
  //     showHideOpacity: true
  //   });
  //   gallery.init();
  // });
});
// $(document).ready(function () {
//   var pswpElement = document.querySelector('.pswp');
//   var items = [];
//   var slideToIndexMap = new Map();

//   var $slides = $('.slider-for .slick-slide').not('.slick-cloned');
//   var imagesToLoad = $slides.length;
//   var imagesLoaded = 0;

//   $slides.each(function (realIndex) {
//     var $slide = $(this);
//     var $img = $slide.find('.photoswipe__image');
//     var imgSrc = $img.attr('src');

//     // Prepend https if needed
//     if (imgSrc && imgSrc.startsWith('//')) {
//       imgSrc = 'https:' + imgSrc;
//     }

//     if ($img.length && imgSrc) {
//       var img = new Image();
//       img.onload = function () {
//         var item = {
//           src: imgSrc,
//           w: img.naturalWidth,
//           h: img.naturalHeight,
//           title: $img.attr('alt') || ''
//         };

//         // Add to items array in order
//         slideToIndexMap.set($slide[0], items.length);
//         items.push(item);
//         imagesLoaded++;

//         if (imagesLoaded === imagesToLoad) {
//           console.log('All images loaded, PhotoSwipe ready.');
//         }
//       };

//       img.onerror = function () {
//         var item = {
//           src: imgSrc,
//           w: 800,
//           h: 600,
//           title: $img.attr('alt') || ''
//         };

//         slideToIndexMap.set($slide[0], items.length);
//         items.push(item);
//         imagesLoaded++;
//       };

//       img.src = imgSrc;
//     }
//   });

//   $('.slider-for').on('click', '.js-photoswipe__zoom', function (e) {
//     e.preventDefault();

//     if (imagesLoaded !== imagesToLoad) {
//       console.warn('Images still loading.');
//       return;
//     }

//     var $slide = $(this).closest('.slick-slide');
//     var realSlide = $slide.get(0);

//     // Find mapped index
//     var itemIndex = slideToIndexMap.get(realSlide);

//     if (itemIndex === undefined) {
//       console.warn('Slide not mapped properly');
//       return;
//     }

//     var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
//       index: itemIndex,
//       bgOpacity: 0.8,
//       showHideOpacity: true
//     });
//     gallery.init();
//   });
// });




$(document).on('click', '.variant-btn', function () {
  const variantId = $(this).data('variant-id');
  const imageUrl = $(this).data('image');
   if (variantId) 
     {
        var selectedVariant = window.product.variants.find(v => v.id == variantId);
        if (selectedVariant && selectedVariant.featured_image) {
          var imageSrc = selectedVariant.featured_image.src.replace(/http(s)?:/, '');
            console.log(imageSrc);
          // Find the index of image in main slider
          var targetIndex = -1;
          $('.quick-view-slider-for img').each(function(index){
            if ($(this).attr('src').includes(imageSrc)) {
              targetIndex = index;
            }
          });
      
          if (targetIndex >= 0) {
            $('.quick-view-slider-for').slick('slickGoTo', targetIndex);
          }
          }
       }
  // Update hidden input with selected variant ID
  $('#product-variant-id').val(variantId);

  // Add .active class
  $('.variant-btn').removeClass('active');
  $(this).addClass('active');

  // Update image if available
  if (imageUrl) {
    $('.product-main-image img').attr('src', imageUrl);
  }
});  

  $(document).on('click', '#add-to-cart-btn', function(e) {  
     var variant_id = jQuery('#product-variant-id').val();
     var updated_qty = jQuery('.updated_qty').val();
       console.log(variant_id);
       e.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: updated_qty,
          id: variant_id
        },
        dataType: 'json',
        success: function(item) {
         
           $('#quick-view-modal').fadeOut();
           window.location.href = '/cart';
        },
        error: function(xhr, status, error) {
          alert('Error: ' + JSON.parse(xhr.responseText).description);
        }
      });
      
    });
  // $('.minus').on('click', function() {
  //    console.log('test');
  //     const $input = $(this).siblings('.js-qty__num');
  //     let currentVal = parseInt($input.val()) || 0;
  //     $input.val(currentVal - 1);
  //     jQuery('.updated_qty').val(currentVal - 1);
      
  //   });
  // $('.plus').on('click', function() {
  //    console.log('test');
  //     const $input = $(this).siblings('.js-qty__num');
  //     let currentVal = parseInt($input.val()) || 0;
  //     $input.val(currentVal + 1);
  //     jQuery('.updated_qty').val(currentVal + 1);
      
  //   }); 
 jQuery(document).on('click', '#newsletter-newsletter-popup .btn', function(e) {
   
    var email = jQuery('#Email-newsletter-popup').val();
    jQuery('.error-msg').hide();   
     if(!email)
             	 {
                    e.preventDefault();
                   jQuery('#Email-newsletter-popup').addClass('error');
                   jQuery('<span class="error-msg">Please enter email address</span>').insertAfter('#newsletter-newsletter-popup');
             	 }
             	 else
                {
                  //console.log("denmjb");
                  if( !validateEmail(email))
                   { 
                     e.preventDefault();   
                    jQuery('#Email-newsletter-popup').addClass('error');
                    emailError = 1;
                    jQuery('<span class="error-msg">Please enter a valid email address</span>').insertAfter('#newsletter-newsletter-popup');

                   }
                else {
                   
                    jQuery('#Email-newsletter-popup').removeClass('error');
                     }
              }
});
});

jQuery(document).ready(function () {
    // Iterate through each link inside .grid-product__title.testing
    jQuery('.grid-product__title.testing a').each(function () {
      var fullText = jQuery(this).text();  // Get the full text
      var maxChars = 60;  // Maximum characters before truncating

      // Save the full text in a data attribute
      jQuery(this).attr('data-full-text', fullText);

      // If the text is longer than the maxChars, truncate it
      if (fullText.length > maxChars) {
        var truncated = fullText.substring(0, maxChars) + '...';
        jQuery(this).text(truncated);  // Update the text to truncated version
      }

      // Hover event to show full text
      jQuery(this).hover(
        function () {
          // Show full text on hover
          jQuery(this).text(jQuery(this).attr('data-full-text'));
        },
        function () {
          // Return to truncated version when hover ends
          var fullText = jQuery(this).attr('data-full-text');
          if (fullText.length > maxChars) {
            var truncated = fullText.substring(0, maxChars) + '...';
            jQuery(this).text(truncated);
          }
        }
      );
    });
  });

  // This function binds the close button event to hide the popup and remove the class
// jQuery(document).ready(function() {
//     // Check if the close button exists
//     if (jQuery('.pswp__button--close').length) {
//         jQuery('.pswp__button--close').on('click', function() {
//             var $popup = jQuery('.pswp');
            
//             // Log to check if the popup has the 'pswp--open' class
//             console.log('Popup open status: ', $popup.hasClass('pswp--open'));
            
//             // Check if the popup is open
//             if ($popup.hasClass('pswp--open')) {
//                 console.log('Closing popup...');
//                 $popup.removeClass('pswp--open');  // Remove the 'pswp--open' class
//                 $popup.attr('aria-hidden', 'true');  // Optional: for accessibility
//                 // $popup.attr('inert', 'true');  // Prevent focus and interaction
//             } else {
//                 console.log('Popup is already closed or has no open class');
//             }
//         });
//     } else {
//         console.log('Close button not found');
//     }
// });


$(".pswp").on("click", ".pswp__button--close", function() {
    // console.log('abc');
    // Example 1: Executing a simple alert after 2 seconds
    setTimeout(function() {
        $(".pswp.pswp--supports-fs").removeClass("pswp--open");
    }, 1000);
});

// Wait for the popup to be ready
document.addEventListener('DOMContentLoaded', function() {
  // console.log("Popup loaded");
  // Select the popup element
  var popup = document.querySelector('.pswp');

  if (popup) {
    // console.log("if Popup loaded");
    // Listen for the close action (you may need to adjust this depending on the library you're using)
    popup.addEventListener('click', function(event) {
      // console.log("if Popup loaded 1");
      // Check if the click is on the close button or overlay
      if (event.target.classList.contains('pswp__button--close') || event.target === popup) {
        console.log("if Popup loaded 2");
        // Call your close event function here
        closePopup();
      }
    });
  }

  // Set up a MutationObserver to watch for changes to aria-hidden
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-hidden'
      ) {
        const isHidden = popup.getAttribute('aria-hidden') === 'true';
        const isStillOpen = popup.classList.contains('pswp--open');

        if (isHidden && isStillOpen) {
          closePopup();
        }
      }
    }
  });
    
  // Start observing the popup for attribute changes
  observer.observe(popup, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });
  
  // Close popup if Escape key is pressed
  document.addEventListener('keydown', function(event) {
    // console.log("event 1");
    if (event.key === 'Escape') {
      // console.log("event 2");
      closePopup();
    }
  });
  
  function closePopup() {
    // Your custom logic for closing the popup
    // console.log("Popup closed");

    // Optionally, you can hide the popup
    popup.classList.remove('pswp--open');
    // popup.setAttribute('aria-hidden', 'true');
    setTimeout(function() {
        $(".pswp.pswp--supports-fs").removeClass("pswp--open");
    }, 1000);
  }
});
$(document).ready(function () {
 setTimeout(function(){
  const pswpElement = document.querySelector('.pswp');
  const items = [];
  const slickIndexToItemIndex = {};

  // Build PhotoSwipe items and map slick index
  $('.slider-for .slick-slide').not('.slick-cloned').each(function () {
    const $slide = $(this);
    const $img = $slide.find('.photoswipe__image');
    let src = $img.attr('src') || '';
    const alt = $img.attr('alt') || '';
    const slickIndex = $slide.data('slick-index');

    if (src.startsWith('//')) {
      src = 'https:' + src;
    }

    if (src && typeof slickIndex !== 'undefined') {
      slickIndexToItemIndex[slickIndex] = items.length;

      items.push({
        src: src,
        w: 800,
        h: 600,
        title: alt
      });
    }
  });

  // Zoom click handler
  $('.slider-for').on('click', '.js-photoswipe__zoom', function (e) {
    e.preventDefault();

    const $clickedSlide = $(this).closest('.slick-slide');
    const slickIndex = $clickedSlide.data('slick-index');
    const itemIndex = slickIndexToItemIndex[slickIndex];

    console.log('Clicked slickIndex:', slickIndex);
    console.log('Resolved itemIndex:', itemIndex);
    console.log('Resolved item:', items[itemIndex]);
     console.log('itemIndex:', itemIndex);
  if (typeof itemIndex === 'undefined' || !items[itemIndex]) {
  console.warn('❌ No matching item for slick index', slickIndex);
  return;
}

  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
    index: itemIndex,
    bgOpacity: 0.8,
    showHideOpacity: true,

  maxSpreadZoom: 2, // Allow zoom up to 2x
  getDoubleTapZoom: function (isMouseClick, item) {
    return item.initialZoomLevel; // Don't zoom on double tap/click
  },
  tapToToggleControls: true, // Keep controls toggle on tap
  pinchToClose: true // Allow mobile pinch to close
  });
  
  gallery.init();

  });
function openPhotoSwipe(itemIndex) {
  const pswpElement = document.querySelector('.pswp');
  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
    index: itemIndex,
    bgOpacity: 0.8,
    showHideOpacity: true,
    showHideOpacityDuration: 300,
    maxSpreadZoom: 2,
    getDoubleTapZoom: function(isMouseClick, item) {
      return item.initialZoomLevel;
    },
    tapToToggleControls: true,
    pinchToClose: true
  });
  gallery.init();
  gallery.listen('afterChange', function () {
  const items = pswpElement.querySelectorAll('.pswp__item');
  items.forEach(el => el.classList.remove('active'));

  // Only 3 pswp__item divs exist — reuse logic
  const currentIndex = gallery.getCurrentIndex() % 3;
  const activeItem = items[currentIndex];
  if (activeItem) activeItem.classList.add('active');
});

}
   setTimeout(() => {
  const zoomBtn = pswpElement.querySelector('.pswp__button--zoom');
  const zoomImg = () => {
    const img = pswpElement.querySelector('.pswp__item.active img');
    if (img) img.classList.toggle('zooming');
  };
  if (zoomBtn) {
    zoomBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      zoomImg();
    });
  }
}, 200);
 $('[data-product-photos]').on('click', '.slick-slide img', function(e) {
  e.preventDefault();
  const slickIndex = $(this).closest('.slick-slide').data('slick-index');
  const itemIndex = slickIndexToItemIndex[slickIndex];
  openPhotoSwipe(itemIndex);
});
   document.querySelector('.pswp__button--arrow--left').addEventListener('click', () => {
      gallery.prev();
    });
    
    document.querySelector('.pswp__button--arrow--right').addEventListener('click', () => {
      gallery.next();
    });
    
    document.querySelector('.pswp__button--close').addEventListener('click', () => {
      gallery.close();
    });
  },1000);  
});


